import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { BasicLink } from 'components/Link'
import { Text } from 'components/Typography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const STableWrapper = styled.div<{ tableModalVisible: boolean; hasLeftSidebar: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: fixed;
  left: calc(
    50vw + ${pxToRem(766 / 2)}rem + ${({ hasLeftSidebar }) => (hasLeftSidebar ? 8 : 3)}rem
  );
  margin-right: 1rem;
  top: 9rem;
  z-index: 10;

  background: var(--c-white);
  box-shadow: 0px 5px 40px #d2dce1;

  @media ${BREAKPOINTS.XL.max} {
    visibility: hidden;
    margin-right: 0;
    ${({ tableModalVisible }) => tableModalVisible && `visibility: visible;`}
    bottom: 0;
    width: unset;
    left: 0;
    right: 0;

    top: unset;
    max-height: calc(100vh - 6rem);
  }
`

export const SOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: var(--c-black);
  opacity: 0.4;

  @media ${BREAKPOINTS.XL.min} {
    display: none;
  }
`

export const SModalTitleRow = styled.div`
  padding: 1rem 1rem 0;
  width: 100%;
  display: flex;
  align-items: center;

  @media ${BREAKPOINTS.XL.min} {
    display: none;
  }
`

export const SModalTitle = styled(Text)`
  color: var(--c-gray100);
  font-weight: bold;
  font-size: 20px;
  flex: 1;
`

export const SCloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  min-height: 1.5rem;
  cursor: pointer;
`

export const SSectionsWrapper = styled.div`
  padding: 1rem;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SSectionWrapper = styled.div`
  cursor: pointer;
  margin-bottom: 1rem;
  width: 100%;

  & :last-of-type {
    margin-bottom: 0;
  }
`

export const SSsectionTitleWrapper = styled.div<{ expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > span {
    color: var(--c-gray100);
  }

  & > svg {
    margin: 0 0.5rem;
    transition: transform 0.2s ease;
    ${({ expanded }) => expanded && `transform: rotate(180deg);`}
  }
`

export const SItemsWrapper = styled.div<{ expanded: boolean }>`
  display: grid;
  grid-gap: 0.75rem;
  overflow: hidden;

  max-height: 20rem;
  padding: 1rem 1rem 0;

  transition: max-height 0.2s ease, padding 0.2s ease;

  ${({ expanded }) => !expanded && `max-height: 0; padding: 0;`}
`

export const SLink = styled(BasicLink)<{ active?: boolean }>`
  text-decoration: none;
  color: var(--c-black);

  ${({ active }) =>
    active &&
    css`
      font-weight: bold;
      color: var(--c-blue500);
    `}
`

export const SToggleButton = styled.button`
  background: var(--c-gray100);
  height: 3.375rem;
  width: 3.375rem;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  right: 1rem;
  margin-bottom: 1rem;
  bottom: env(safe-area-inset-bottom, 1rem);
  box-shadow: 0px 5px 40px #d2dce1;

  @media ${BREAKPOINTS.XL.max} {
    display: flex;
  }
`
